// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","savedSearchListItem":"_2xJKzvdPvM8oclk0KZ3eC4","savedSearchListArea":"_2p80_3qaKCbPk66zIiD_4_"};